import useSearchParam from '../useSearchParam';
import { initialGroupsSearchFilter } from '../../constants/groups/filter';
import { SearchDateTerms } from '../../types/common/searchfilter';

export interface CLOSETGroupsInitialSearchParams {
  dateInterval: string[];
  dateTerm: SearchDateTerms | null;
  planTypeValues: number[];
  paymentMethodValues: number[];
  keyword: string;
  managerEmail: string | null;
}

export const useCLOSETGroupsInitialSearchParams = (): CLOSETGroupsInitialSearchParams => {
  const searchParams = useSearchParam();

  return {
    dateInterval:
      searchParams.get('dateInterval')?.split(',') || initialGroupsSearchFilter.dateInterval,
    dateTerm:
      Number(searchParams.get('dateTerm')?.split(',')) || initialGroupsSearchFilter.dateTerm,
    planTypeValues:
      searchParams
        .get('planTypeValues')
        ?.split(',')
        ?.map(value => Number(value)) || initialGroupsSearchFilter.planTypeValues,
    paymentMethodValues:
      searchParams
        .get('paymentMethodValues')
        ?.split(',')
        ?.map(value => Number(value)) || initialGroupsSearchFilter.paymentMethodValues,
    keyword: searchParams.get('keyword') || initialGroupsSearchFilter.keyword,
    managerEmail: searchParams.get('manager'),
  };
};
